import IcoMoon, { IconProps } from 'react-icomoon';
import iconSet from './selection.json';

// @ts-ignore
const Icon = (props: IconProps) => <IcoMoon iconSet={iconSet} {...props} />;

export default Icon;
